<template>
  <div class="row">
    <div class="col-lg-12">
      <card>
        <template slot="header">
          <h3 class="card-title">{{ $t('dashboard.dashboard') }}</h3>
        </template>
        <div v-if="loggedUser.active" class="card-body">
          <div class="row">
            <div class="font-icon-list col-lg-12">
              <div @click="() => $router.push('/grants')" class="font-icon-detail application-button">
                <i class="tim-icons icon-notes"></i>
                <h4>{{ $t('dashboard.apply_for_new') }}</h4>
              </div>
            </div>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
  import {BaseAlert} from 'src/components';
  import {AuthService} from "@/services";

  export default {
    components: {
      BaseAlert
    },
    data() {
      return {
        resentConfirmationEmail: false
      }
    },
    computed: {
      loggedUser() {
        return this.$store.getters['Auth/loggedUser'];
      }
    },
    methods: {
      async resendConfirmationEmail() {
        let loader = this.$loading.show();

        let success = false;
        await AuthService.resendConfirmEmail().then((res) => {
          success = true;
        }).catch((error) => {
          alert('Could not resend email, please try again later.');
        });

        if (success) {
          let email = this.$store.getters['Auth/loggedUser'].email;

          this.resentConfirmationEmail = true;

          this.$notify({
            message: this.$t('dashboard.email_confirmation_resent_success', [email]).split("\n").join("<br>"),
            timeout: 5000,
            icon: 'tim-icons icon-bell-55',
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'info'
          });
        }

        loader.hide();
      }
    }
  }
</script>
<style lang="scss">
  .white-content .font-icon-detail i {
    color: $gray-500;
  }

  .application-button {
    cursor: pointer;

    &.font-icon-detail {
      border: none;
    }

    i {
      font-size: 5rem;
    }

    h4 {
      margin-top: 2rem;
    }
  }
</style>
